window.addEventListener('load', () => {
    $('form.like').on('submit', function (e) {
        e.preventDefault();

        let $form = $(this);
        let like = $form.find("input[name='like']").val() == 1;

        window.axios.post($form.attr('action'), $form.serialize())
        .then(function (res) {
            let data = res.data.data;

            $('#likes_count').html(data.likesCount);
            $('#dislikes_count').html(data.dislikesCount);

            let s = new snackbar();
            s.closeable = true;

            if (data.liked) {
                $form.find('.btn-like').addClass('btn-success').removeClass('btn-outline-success');
                $form.find('.btn-dislike').removeClass('btn-danger').addClass('btn-outline-danger');
                s.success("Merci pour ton like");
            } else if(data.disliked) {
                $form.find('.btn-dislike').addClass('btn-danger').removeClass('btn-outline-danger');
                $form.find('.btn-like').removeClass('btn-success').addClass('btn-outline-success');
                s.danger("Ohhh, c'est dommage...");
            }else{
                $form.find('.btn-dislike').removeClass('btn-danger').addClass('btn-outline-danger');
                $form.find('.btn-like').removeClass('btn-success').addClass('btn-outline-success');
            }
        })
        .catch(function (err) {
            if (err.response) {
                let message = err.message;
                if (err.response.status === 401 || err.response.data.errors.member_id) {
                    message = "Tu dois être connecté pour ça...";
                }
                let s = new snackbar();
                s.closeable = true;
                s.danger(message);
            }
        })
    })
});
